// with Error Handling
import { useState, useEffect } from "react";
import axios, { AxiosResponse, AxiosError } from "axios";
import { apibaseurl, jwttoken } from "../environment";
import { useNavigate } from "react-router-dom";

interface ApiOptions {
  method?: "GET" | "POST" | "DELETE";
  payload?: Record<string, any> | null;
  autoCall?: boolean;
  dependencies?: any[];
  isBinary?: boolean;
}

interface UseApiResult<T> {
  data: T | null;
  // categoryummary?: T | null;
  loading: boolean;
  error: any;
  callApi: (
    payload?: Record<string, any>,
    customEndpoint?: string
  ) => Promise<T | undefined>;
}

function useApi<T = any>(
  endpoint: string,
  {
    method = "GET",
    payload = null,
    autoCall = true,
    dependencies = [],
    isBinary = false,
  }: ApiOptions = {}
): UseApiResult<T> {
  const [data, setData] = useState<T | null>(null);
  const [categorySummary, setCategorySummary] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(autoCall);
  const [error, setError] = useState<any>(null);
  const navigate = useNavigate();

  const callApi = async (
    customPayload = payload,
    customEndpoint: string = ""
  ): Promise<T | undefined> => {
    setLoading(true);
    try {
      endpoint = method === "GET" && customEndpoint ? customEndpoint : endpoint;
      // console.log(endpoint);
      const config: any = {
        headers: {
          Authorization: `Bearer ${jwttoken}`,
          // "Content-Type": "application/json",
        },
        timeout: 60000, // add timeout api call
        data: method === "DELETE" ? customPayload : undefined,
      };

      if (isBinary) {
        config.responseType = "arraybuffer";
        config.headers["Content-Type"] = "application/pdf";
      } else {
        config.headers["Content-Type"] = "application/json";
      }

      let response: AxiosResponse<any>;

      if (method === "POST") {
        response = await axios.post(
          `${apibaseurl}${endpoint}`,
          customPayload,
          config
        );
      } else if (method === "DELETE") {
        response = await axios.delete(`${apibaseurl}${endpoint}`, config);
      } else {
        response = await axios.get(`${apibaseurl}${endpoint}`, config);
      }

      // console.log(response?.data?.data, "Direct Coming from Api Hook");
      // setData(response?.data);
      setData(isBinary ? (response.data as any) : response.data);
      // setCategorySummary(response)
      // console.log(response?.category_summary);

      setError(null);
      setTimeout(() => setLoading(false), 1000);
      return response.data;
    } catch (err) {
      const axiosErr = err as AxiosError;

      // if (
      //   axiosErr.code === "ECONNABORTED" ||
      //   axiosErr.message === "Network Error"
      // ) {
      //   console.error(
      //     "🚨 Connection not established (backend down or unreachable)"
      //   );
      //   navigate("/error-500");
      // } else
      if (axiosErr.response) {
        // API reached but returned an error
        console.error(
          `⚠️ API not working (${endpoint})`,
          axiosErr.response.status,
          axiosErr.response.data
        );
      } else {
        console.error("❌ Unexpected Error:", axiosErr.message);
      }

      setError(err);
      setTimeout(() => setLoading(false), 1000);
    }
  };

  useEffect(() => {
    if (autoCall) {
      callApi();
    }
  }, dependencies);

  return { data, loading, error, callApi };
}

export default useApi;

// -------------------------------------------------------------

// import { useState, useEffect } from "react";
// import axios, { AxiosResponse } from "axios";
// import { apibaseurl, jwttoken } from "../environment";
// import { useNavigate } from "react-router-dom";

// interface ApiOptions {
//   method?: "GET" | "POST" | "DELETE";
//   payload?: Record<string, any> | null;
//   autoCall?: boolean;
//   dependencies?: any[];
// }

// interface UseApiResult<T> {
//   data: T | null;
//   loading: boolean;
//   error: any;
//   callApi: (payload?: Record<string, any>) => Promise<T | undefined>;
// }

// function useApi<T = any>(
//   endpoint: string,
//   {
//     method = "GET",
//     payload = null,
//     autoCall = true,
//     dependencies = [],
//   }: ApiOptions = {}
// ): UseApiResult<T> {
//   const [data, setData] = useState<T | null>(null);
//   const [loading, setLoading] = useState<boolean>(autoCall);
//   // const [errorLoading, setErrorLoading] = useState<boolean>(false);
//   const [error, setError] = useState<any>(null);

//   const navigate = useNavigate();

//   const callApi = async (customPayload = payload): Promise<T | undefined> => {
//     setLoading(true);
//     try {
//       const config = {
//         headers: {
//           Authorization: `Bearer ${jwttoken}`,
//           "Content-Type": "application/json", // <-- ADD THIS
//         },
//         data: method === "DELETE" ? customPayload : undefined,
//       };

//       // ✅ Log the outgoing request
//       // console.log("Calling API:", {
//       //     url: `${apibaseurl}${endpoint}`,
//       //     method,
//       //     payload: customPayload,
//       //     config,
//       // });

//       let response: AxiosResponse<any>;

//       if (method === "POST") {
//         response = await axios.post(
//           `${apibaseurl}${endpoint}`,
//           customPayload,
//           config
//         );
//       } else if (method === "DELETE") {
//         response = await axios.delete(`${apibaseurl}${endpoint}`, config);
//       } else {
//         response = await axios.get(`${apibaseurl}${endpoint}`, config);
//       }

//       setData(response?.data);
//       setError(null);
//       setTimeout(() => setLoading(false), 1000);
//       return response.data;
//     } catch (err) {
//       console.error("API Error:", err);
//       setError(err);
//       // window.location.href = "/error-404";
//       // navigate("/error-404");
//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//       // throw err;
//     }
//     // finally {
//     // setLoading(false);
//     // }
//   };

//   useEffect(() => {
//     if (autoCall) {
//       callApi();
//     }
//   }, dependencies);

//   return { data, loading, error, callApi };
// }

// export default useApi;

// ---------------------------------**************************** old vk code *****************************
// import { useState, useEffect } from "react";
// import axios, { AxiosResponse } from "axios";
// import { apibaseurl, jwttoken } from "../environment";

// interface ApiOptions {
//   method?: "GET" | "POST" | "DELETE";
//   payload?: Record<string, any> | null;
//   autoCall?: boolean;
//   dependencies?: any[];
// }

// interface UseApiResult<T> {
//   data: T | null;
//   loading: boolean;
//   error: any;
//   callApi: (payload?: Record<string, any>) => Promise<T>;
// }

// function useApi<T = any>(
//   endpoint: string,
//   {
//     method = "GET",
//     payload = null,
//     autoCall = true,
//     dependencies = [],
//   }: ApiOptions = {}
// ): UseApiResult<T> {
//   const [data, setData] = useState<T | null>(null);
//   const [loading, setLoading] = useState<boolean>(autoCall);
//   const [error, setError] = useState<any>(null);

//   const callApi = async (customPayload = payload): Promise<T> => {
//     setLoading(true);
//     try {
//       const config = {
//         headers: {
//           Authorization: `Bearer ${jwttoken}`,
//           "Content-Type": "application/json", // <-- ADD THIS
//         },
//         data: method === "DELETE" ? customPayload : undefined,
//       };

//       // ✅ Log the outgoing request
//       // console.log("Calling API:", {
//       //     url: `${apibaseurl}${endpoint}`,
//       //     method,
//       //     payload: customPayload,
//       //     config,
//       // });

//       let response: AxiosResponse<any>;

//       if (method === "POST") {
//         response = await axios.post(
//           `${apibaseurl}${endpoint}`,
//           customPayload,
//           config
//         );
//       } else if (method === "DELETE") {
//         response = await axios.delete(`${apibaseurl}${endpoint}`, config);
//       } else {
//         response = await axios.get(`${apibaseurl}${endpoint}`, config);
//       }

//       setData(response.data);
//       setError(null);
//       return response.data;
//     } catch (err) {
//       console.error("API Error:", err);
//       setError(err);
//       // if (error?.code == "ERR_BAD_REQUEST" || err) {
//       //   setTimeout(() => (window.location.href = "/error-404"), 500);
//       // }
//       window.location.href = "/error-404";

//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (autoCall) {
//       callApi();
//     }
//   }, dependencies);

//   return { data, loading, error, callApi };
// }

// export default useApi;
